/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OfferInputDto { 
    dsCode: string;
    dsDescription: string;
    qtMinCartValue?: number;
    nmType: number;
    qtValue: number;
    qtUpto?: number;
    isEnabled: boolean;
    isShipping: boolean;
    dtValidTill?: Date;
    cdsStores?: Array<number>;
}